import { array, integer, object } from 'superstruct';
export const EditUserRolesDto = object({
  roles: array(object({
    id: integer()
  }))
});